<template>
<div id="wrapper">
    <!-- SkipNav -->
    <div id="skipNav">
        <ul>
            <li><a href="#content" tabindex="0">본문 바로가기</a></li>
        </ul>
    </div>
    <!-- //SkipNav -->

    <!-- Header -->
    <Header ref="header"></Header>
    <!-- //Header -->

    <!-- 2025.04.29 송준형 : REQSDP-7193 - lgappstv.com 한국 웹접근성 심사결과 대응 2025년 -->
    <!-- 전체검색 -->
    <IntegratedSearch></IntegratedSearch>
    <!-- //전체검색 -->

    <!-- Container -->
    <div id="container" class="out-sec">
        <router-view />
    </div>
    <!-- //Container -->

    <!-- 챗봇 -->
    <aside class="float-wrap">
        <div id="chatbot" class="float-chatbot" v-show="cntryCode == 'KR' || cntryCode == 'US'">
            <button type="button" class="btn-ico" @click="goChatbot()" :title="$t('gwa.alt.common.wa_title_4')"><span><i class="ico ico-chatbot">Chatbot</i></span></button>
        </div>
        <div class="float-pageUp">
            <button type="button" class="btn" :title="$t('gwa.alt.common.wa_title_60')"><span><i class="arw arw-up"></i><em>Top</em></span></button>
        </div>
    </aside>
    <!-- //챗봇 -->

    <!-- Footer -->
    <Footer></Footer>
    <!-- //Footer -->

    <div id="pageLoading" class="loadingDim-wrap">
        <div class="loading"><img src="/img/cmn/loading.png" alt="로딩중"></div>
    </div>

    <!-- C20200615_50615 : 2020.06.23 송준형 START -->
    <!--<div>-->
        <!--<GAPop></GAPop>-->
    <!--</div>-->
    <!-- C20200615_50615 : 2020.06.23 송준형 START -->
</div>
</template>

<script>

    import qs from "qs";

    import Header from '@/components/nav/Header';
    import Footer from '@/components/nav/Footer';
    import IntegratedSearch from '@/components/integratedsearch/IntegratedSearch';
    import GAPop from "@/components/terms/GAPop";

	export default {
		name: "App",
		components: {
            Header,
            Footer,
            IntegratedSearch,
            GAPop
		},
		data() {
			return {
                isLogin: false,
                cntryCode : "",
                langCode : "" // REQSDP-1550 : 2022.04.12 송준형 - [PC webiste] 챗봇 URL 및 이미지변경 요청
			}
        },
			computed: {

			},
			watch: {
				'$route': 'changeRoute'
			},
			mounted() {
				console.log('App.vue mounted..');

				var firstName = this.getCookie('firstName');
				var lastName = this.getCookie('lastName');
				if(firstName == null || lastName == null) {
					this.isLogin = false;
				} else {
					this.isLogin = true;
				}

                this.cntryCode = _domainCntryCode;
				this.langCode = _domainLangCode; // REQSDP-1550 : 2022.04.12 송준형 - [PC webiste] 챗봇 URL 및 이미지변경 요청

                // 2024.06.21 송준형 : REQSDP-5357 - PC Mall 웹접근성 심사결과대응 2차
                $("#searchAll").on("focus", function() {
                    if($("#searchAll").attr("aria-hidden") == "true") {
                        $("#container").focus();
                    }
                });

                // 2025.05.29 송준형 : REQSDP-7378 - lgappstv.com 한국 웹접근성 심사결과 대응 2025년 (잔여)
                $("#container").on("focusin", function() {
                  if($("#searchAll").attr("aria-hidden") == "false") {
                    $("#searchCloseBtn").focus();
                  }
                });

                // 2024.12.17 송준형 : REQSDP-6333 - PCMall LMP(멤버스) 로그인 연동 방식 개선 개발
                const pageShowEventHandler = (e) => {
                    var loginBackYn = "N";

                    if(e.persisted || (window.performance && window.performance.navigation.type == 2)) {
                        if(this.$store.state.loginYn == "Y") {
                            loginBackYn = "Y";
                        }
                    }

                    this.$store.state.loginYn = "N";
                    if(loginBackYn == "Y") {
                        this.$router.go(-1);
                    }
                };
                window.addEventListener('pageshow', pageShowEventHandler);
			},
		methods : {
			changeRoute(to, from) {
				console.log('Main.vue', 'changeRoute', to, from);
                console.log(this.$refs.header.changeMenu(to));
                
                // ui.searchAll.close('searchAll'); // 검색바 닫힘

                // 2021.02.05 송준형 : C20210205_77310 - PC Mall 코드 내 meta_name field 추가 요청드립니다.
                if($("meta[name='appstore:developer_url']").length) {
                    $("meta[name='appstore:developer_url']").remove();
                    $("meta[name='appstore:bundle_id']").remove();
                    $("meta[name='appstore:store_id']").remove();
                }

                $("#wrapper").attr("tabindex", 0); // 2023.06.23 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년
                $("#wrapper").focus(); // 2023.06.23 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년

                if($(".dimmer-popup").length) { // 2024.06.13 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년
                    dimmer.close('dimmer-popup', 0.6);
                }
			},
            logout() {
                const vm = this;
                this.$axios.get('/api/main/logout.ajax').then((result) => {
                    console.log('document.cookie', document.cookie);
                    this.isLogin = false;
                })
            },
		    goChatbot() {
			    const params = {
			        cntryCode: this.cntryCode.toLowerCase(),
                    langCode: this.langCode.toLowerCase() // REQSDP-1550 : 2022.04.12 송준형 - [PC webiste] 챗봇 URL 및 이미지변경 요청
                };

                this.$axios.post('/api/main/retrieveChatBotUrl.ajax', qs.stringify(params)).then((result) => {
                    var newWindow = window.open(result.data.url, "_blank", 'left=0, top=0, width=360, height=620, resizable=yes');
                    newWindow.location.href = result.data.url;
                });
            },
            goLgaccount() {
                // 2024.12.17 송준형 : REQSDP-6333 - PCMall LMP(멤버스) 로그인 연동 방식 개선 개발
                const r = { path : "/main/loginLink" };
                this.$router.push(r);
            },
		    retrieveFamilySite(event) {
                  if (event.target.value == "smartWorld") {
                      window.location.href = "http://www.lgworld.com/web.gateway.dev";
                  } else if (event.target.value == "sellerLounge") {
                      window.location.href = "http://seller.lgappstv.com/seller/main/Main.lge";
                  } else if (event.target.value == "developer") {
                      window.location.href = "http://webostv.developer.lge.com/";
                  }
		    },
            getCookie(cname) {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for(var i = 0; i <ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        var str = c.substring(name.length, c.length);
                        if(str === null || str === '') {
                            return null;
                        } else {
                            return str;
                        }
                    }
                }
                return null;
            }
		}
	};
</script>

<style>
</style>
